<template>
    <aside class="delivery-sec__aside">
        <nav class="delivery-sec__nav">
            <ul class="list delivery-nav-list">

                <li class="list__element delivery-nav-list__element " v-if="this.$store.state.settings.user"
                    :class="page === 'personal'? 'active-link' : '' ">
                    <a href="/personal" class="delivery-nav-list__link">{{ this.trans("Personal information") }}</a>
                </li>
                <li class="list__element delivery-nav-list__element"
                    :class="page === 'history'? 'active-link' : '' ">
                    <a href="/history" class="delivery-nav-list__link">{{ this.trans("Order history") }}</a>
                </li>
                <li class="list__element delivery-nav-list__element" v-if="this.$store.state.settings.user">
                  <form action="/logout" method="post">
                    <input type="hidden" name="_token" :value="csrf">
                    <input type="submit" :value="this.trans('Exit')" class="delivery-nav-list__link exit">

                  </form>

                </li>
                <li class="list__element delivery-nav-list__element" v-if="!this.$store.state.settings.user"
                    :class="page === 'login'? 'active-link' : '' ">
                    <a href="/login" class="delivery-nav-list__link">{{ this.trans("Authorization") }}</a>
                </li>
                <li class="list__element delivery-nav-list__element" v-if="!this.$store.state.settings.user"
                    :class="page === 'register'? 'active-link' : '' ">
                    <a href="/register" class="delivery-nav-list__link">{{ this.trans("Registration") }}</a>
                </li>
                <li class="list__element delivery-nav-list__element" v-if="this.$store.state.settings.user?.role_id >=  500">
                    <a :href="adminPath" class="delivery-nav-list__link">{{ this.trans("Admin Panel") }}</a>
                </li>

                <li class="list__element delivery-nav-list__element" v-if="this.$store.state.settings.user">
                    <a href="#" class="delivery-nav-list__link" @click="deleteProfile"
                       :title="this.trans('Your profile will be permanently deleted')+'. '+ this.trans('Delete a profile?')">{{this.trans("Delete a profile?")}}</a>
                </li>

            </ul>
        </nav>
    </aside>
</template>

<script>
import Swal from 'sweetalert2-neutral'

export default {
    props: {
        page: String,
    },
    name: 'my-aside',
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        };
    },
    computed: {
        adminPath() {
            return import.meta.env.VITE_ADMIN_PATH || 'https://admin.batnorton.com/admin';
        }
    },
    methods: {
        logout() {

            axios.post('/logout').then(r => {
                localStorage.removeItem('csrf_token');
                localStorage.removeItem('is_vip_guest');
                this.$store.state.settings.user = null;
                this.updateStorage(this.$store.state.settings);
                this.$router.push({name: 'login'});
            });

        },
        deleteProfile() {
            Swal.fire({
                title: this.trans('Your profile will be permanently deleted') + '. ' + this.trans('Delete a profile?'),
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: this.trans('Yes'),
                denyButtonText: this.trans('Don\'t save'),
                cancelButtonText: this.trans('Cancel'),
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {

                    axios.get('/api/v1/delete-user', {
                        params: this.setParam({
                            user: this.$store.state.settings.user.id,
                        }),
                    }).then(r => {
                        this.$notify({
                            title: r.data.title,
                            text: r.data.text,
                            type: r.data.status,
                        });
                        axios.post('/logout').then(r => {
                            localStorage.removeItem('csrf_token');
                            localStorage.removeItem('is_vip_guest');
                            this.$store.state.settings.user = null;
                            this.updateStorage(this.$store.state.settings);
                            window.location.href = '/login';

                        });

                    });

                } else if (result.isDenied) {
                    Swal.fire(this.trans('Changes are not saved'), '', 'info');
                }
            });
        },

    },
    mounted() {

    },
};
</script>

<style scoped>
.exit {
    cursor: pointer;
    background: #fff;
    border: none;
    font-size: 16px;
}
</style>
